import script from "./RenderBreadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./RenderBreadcrumb.vue?vue&type=script&setup=true&lang=js"

import "./RenderBreadcrumb.vue?vue&type=style&index=0&id=ea906ed6&scoped=true&lang=css"

import exportComponent from "/Users/wangcaijuan/var/www/oa-show/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea906ed6"]])

export default __exports__